"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveStagedChanges = exports.SaveStagedChanges = exports.SaveStagedChangesActionTypes = exports.clearStagedChanges = exports.StagingActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _I18n = _interopRequireDefault(require("I18n"));

var _actions = require("settings-ui-lib/utils/actions");

var _fluxActions = require("flux-actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var StagingActionTypes = (0, _namespacedKeyMirror.default)({
  CLEAR_STAGED_CHANGES: null,
  SAVE_STAGED_CHANGES: null
}, 'analytics-and-tracking');
exports.StagingActionTypes = StagingActionTypes;
var clearStagedChanges = (0, _fluxActions.createAction)(StagingActionTypes.CLEAR_STAGED_CHANGES);
exports.clearStagedChanges = clearStagedChanges;
var SaveStagedChangesActionTypes = (0, _actions.createRequestTypes)(StagingActionTypes.SAVE_STAGED_CHANGES);
exports.SaveStagedChangesActionTypes = SaveStagedChangesActionTypes;
var SaveStagedChanges = (0, _actions.createRequestActions)(SaveStagedChangesActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SaveStagedChangesActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('analyticsAndTracking.saved.success')));
  }
});
exports.SaveStagedChanges = SaveStagedChanges;
var saveStagedChanges = (0, _fluxActions.createAction)(StagingActionTypes.SAVE_STAGED_CHANGES);
exports.saveStagedChanges = saveStagedChanges;